<template>
  <div>
    <template v-if="currentView == 'list'">
      <v-container fluid>
        <h1 class="headline">Auto Training</h1>
        <v-layout>
          <v-flex>
            <v-text-field
              id="search"
              v-model="search"
              name="search"
              outline
              class="default-input"
              placeholder="search conversation name"
              style="max-width: 300px"
              clearable
              :loading="loading"
              :disabled="loading"
            />
          </v-flex>
          <!-- <v-flex shrink>
          <v-btn
            outline
            color="primary"
            :loading="loading"
            :disabled="selectedAutoTraining && selectedAutoTraining.length == 0"
            @click="handleExportAnwsers"
          >
            <em class="fas fa-file-export" />
            &nbsp;
            {{ $t('export') }}&nbsp;
          </v-btn>
        </v-flex> -->
        </v-layout>

        <v-layout>
          <v-flex shrink>
            <v-btn
              color="primary"
              :disabled="selectedAutoTraining && selectedAutoTraining.length == 0"
              :loading="loading"
              @click="handleAddToSpam"
            >
              <v-icon class="mr-2">report</v-icon>Spam
            </v-btn>
            <v-btn
              color="primary"
              :disabled="selectedAutoTraining && selectedAutoTraining.length == 0"
              :loading="loading"
              @click="handleAddToIgnore"
            >
              <v-icon class="mr-2">block</v-icon> Ignored
            </v-btn>
            <v-menu offset-y>
              <template #activator="{ on }">
                <v-btn
                  color="primary"
                  :disabled="selectedAutoTraining && selectedAutoTraining.length == 0"
                  :loading="loading"
                  v-on="on"
                >
                  <v-icon class="mr-2">add</v-icon> Add to conversation
                </v-btn>
              </template>
              <v-list>
                <v-list-tile @click="handleAddToNewConversation">
                  <v-list-tile-title>Add new</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="handleAddToExistingConversation">
                  <v-list-tile-title>Add existing</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-flex>
          <v-flex class="text-xs-right">
            <v-btn
              icon
              color="primary"
              outline
              class="refresh-button"
              :loading="loading"
              @click="handleFetchAutoClassify()"
            >
              <v-icon>refresh</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>

        <div v-if="loading" class="my-4 text-xs-center">
          <v-progress-circular indeterminate color="primary" />
        </div>

        <div v-else-if="conversations.length == 0" class="my-4 text-xs-center">No data</div>
        <div v-else class="my-2">
          <template v-for="conversation in conversations">
            <AutoTrainingItem
              :key="conversation.id"
              style="margin-bottom: 10px"
              :conversation="conversation"
              @onAddToConversation="onAddToConversation"
            />
          </template>
          <div class="text-xs-center">
            <v-pagination v-model="page" :length="pageCount" />
          </div>
        </div>
      </v-container>

      <!-- Add existing conversation -->

      <v-dialog v-model="showDialogAddExisting" scrollable persistent max-width="1000">
        <v-card>
          <template v-if="showDialogAddExisting">
            <div class="pa-2">
              <h1>{{ $t('Training') }}</h1>
              <div class="form-control">
                <input v-model="searchIntent" type="text" :placeholder="$t('Search')" />
              </div>
            </div>

            <v-divider />
            <v-card-text style="max-height: 600px">
              <ul class="training-data" style="margin: 0; padding: 0">
                <li
                  v-for="(intent, index) in filterIntents"
                  :key="'intent_' + index"
                  class="item z-border-red mb-2"
                >
                  <v-layout class="training-title">
                    <v-flex class="pa-2">
                      {{ intent.intentname }}
                    </v-flex>
                    <v-flex shrink>
                      <v-btn color="primary" @click="saveToExistingConversation(intent)">
                        {{ $t('select') }}
                      </v-btn>
                    </v-flex>
                    <v-flex shrink>
                      <v-btn icon @click="handleSelectPreviewIntent(intent)">
                        <v-icon>
                          {{
                            currentIntent && currentIntent.id == intent.id
                              ? 'keyboard_arrow_up'
                              : 'keyboard_arrow_down'
                          }}
                        </v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <template v-if="currentIntent && currentIntent.id == intent.id">
                    <v-divider />
                    <PreviewConversation
                      class="pa-2"
                      :show-multiple-channel="showMultipleChannel"
                      :intent="intent"
                      :answers="answers"
                      :tab="tab"
                      :multi-messages="{
                        fb_answers,
                        line_answers,
                        ig_answers,
                        ms_team_answers
                      }"
                      :fb_answers="fb_answers"
                      :line_answers="line_answers"
                      :ig_answers="ig_answers"
                      :ms_team_answers="ms_team_answers"
                      @handleChangeTab="tab = $event"
                    />
                  </template>
                </li>
              </ul>
            </v-card-text>

            <v-divider />
            <v-card-actions>
              <v-spacer />
              <v-btn color="primary" depressed @click="showDialogAddExisting = false">{{
                $t('cancel')
              }}</v-btn>
              <v-spacer />
            </v-card-actions>
          </template>
        </v-card>
      </v-dialog>

      <!-- Review anwser before add -->

      <v-dialog v-model="showDialogReviewToAdd" scrollable persistent max-width="800px">
        <v-card>
          <v-card-text>
            <QuestionDataExample
              :selected="selectedAutoTraining"
              :questions="selectedAutoTraining.map((val) => ({ questiondata: val }))"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn class="skip-btn" depressed @click="handleCancelReview">{{ $t('cancel') }}</v-btn>
            <v-btn color="primary" @click="handleSubmitReview">{{ $t('submit') }}</v-btn>
            <v-spacer />
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- confirm anwser before add -->

      <v-dialog v-model="showDialogConfirmToAdd" scrollable persistent max-width="400">
        <v-card>
          <v-card-text class="text-xs-center">
            <template v-if="addType == 'spam'">
              ยืนยันที่จะ<span class="primary--text">บันทึกในสแปม</span>หรือไม่?<br />
              ข้อความนี้จะถูกส่งเข้าไปที่สแปม<br />
              ในหน้าบทสนทนา (conversation)
            </template>
            <template v-else-if="addType == 'ignored'">
              ยืนยันที่จะบันทึกใน
              <span class="primary--text">Ignored conversation </span>หรือไม่?<br />
              ข้อความนี้จะถูกส่งเข้าไปท Ignored conversation<br />
              ในหน้าบทสนทนา (conversation)
            </template>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn class="skip-btn" depressed @click="handleCancelConfirmReview">{{
              $t('cancel')
            }}</v-btn>
            <v-btn color="primary" @click="handleSubmitConfirmReview">{{ $t('submit') }}</v-btn>
            <v-spacer />
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Success -->
      <v-dialog v-model="showDialogSuccessToAdd" scrollable persistent max-width="400">
        <v-card>
          <v-card-text class="text-xs-center"> บันทึกเรียบร้อยแล้ว </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn full-width depressed @click="handleGoToConversation">{{
              addType == 'spam' ? $t('ดูสแปมของฉัน') : $t('ดู Ignored conversation ของฉัน')
            }}</v-btn>
            <v-btn full-width color="primary" @click="handleCloseSuccess">{{
              $t('ฝึกฝนบอทต่อ')
            }}</v-btn>
            <v-spacer />
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template v-else-if="currentView == 'create_new'">
      <v-container>
        <manage-intent
          v-model="newIntent"
          :type="'add'"
          :excluded-intent-name="excludedIntentName"
          @close="onCloseIntent"
          @saveIntent="onSaveIntent"
        ></manage-intent>
      </v-container>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AutoTrainingItem from './AutoTrainingItem.vue'
import autoTrainingApi from '@/api/auto-training'
import intentApi from '@/api/intent.js'
import { handleResponse, handleApiError } from '@/api/util'
import ManageIntent from '@/components/view/intent/intent-manage'
import PreviewConversation from '@/components/elements/Conversation/PreviewConversation'
import api from '@/api'
import XLSX from 'xlsx'
import QuestionDataExample from './QuestionDataExample.vue'
export default {
  components: {
    AutoTrainingItem,
    ManageIntent,
    PreviewConversation,
    QuestionDataExample
  },
  data() {
    return {
      currentView: 'list',
      page: 1,
      conversations: [],
      searchTimeout: null,
      maxItems: 10,
      total: 0,
      offset: 0,
      intents: [],
      loadingGetAutoTraining: true,
      loadingIntent: false,

      newIntent: {},
      showDialogAddExisting: false,
      currentIntent: null,
      tab: 'fb',
      searchIntent: '',
      addType: '',
      showDialogReviewToAdd: false,
      showDialogSuccessToAdd: false,
      showDialogConfirmToAdd: false,
      spamConversation: null,
      ignoreConversation: null,
      search: ''
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    loading() {
      return this.loadingGetAutoTraining || this.loadingIntent
    },
    excludedIntentName: function () {
      const vm = this
      const result = vm.intents.map((intent) => {
        return intent && intent.intentname ? intent.intentname : null
      })

      return (result || []).join(',')
    },
    pageCount() {
      let l = this.total || 0
      let s = this.maxItems
      return Math.ceil(l / s)
    },
    selectedAutoTraining() {
      return this.$store.state.selectedAutoTraining
    },
    filterIntents: function () {
      const vm = this
      vm.intents.slice(0).sort(function (a, b) {
        const nameA = a.intentname.toUpperCase() // ignore upper and lowercase
        const nameB = b.intentname.toUpperCase() // ignore upper and lowercase
        if (a.intentname[0] == '{' && a.intentname[a.intentname.length - 1] == '}') {
          return 1
        }
        if (b.intentname[0] == '{' && b.intentname[b.intentname.length - 1] == '}') {
          return -1
        }
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }
        // names must be equal
        return 0
      })

      return vm.intents.filter((intent) => {
        if (intent && intent.intentname) {
          return (
            intent.intentname &&
            ((vm.searchIntent != undefined &&
              intent.intentname.toLowerCase().includes(vm.searchIntent.toLowerCase())) ||
              vm.searchIntent == '')
          )
        } else return false
      })
    },
    answers: function () {
      const vm = this
      if (!vm.currentIntent) {
        return [[]]
      }
      try {
        return vm.formatAnswer(vm.currentIntent.a_val, vm.currentIntent.a_type)
      } catch (error) {
        return [[]]
      }
    },
    showMultipleChannel() {
      if (!this.currentIntent) {
        return false
      }
      const hasMultipleChannel = this.conversationSocialChannelOptions.find((social) => {
        return (
          Object.prototype.hasOwnProperty.call(this.currentIntent, `${social.value}_val`) &&
          this.currentIntent[`${social.value}_val`]
        )
      })
      return hasMultipleChannel ? true : false
    },
    fb_answers() {
      const vm = this
      if (!vm.currentIntent) {
        return [[]]
      }
      try {
        return vm.formatAnswer(vm.currentIntent.fb_val, 'json')
      } catch (error) {
        return [[]]
      }
    },
    line_answers() {
      const vm = this
      if (!vm.currentIntent) {
        return [[]]
      }
      try {
        return vm.formatAnswer(vm.currentIntent.line_val, 'json')
      } catch (error) {
        return [[]]
      }
    },
    ig_answers() {
      const vm = this
      if (!vm.currentIntent) {
        return [[]]
      }
      try {
        return vm.formatAnswer(vm.currentIntent.ig_val, 'json')
      } catch (error) {
        return [[]]
      }
    },
    ms_team_answers() {
      const vm = this
      if (!vm.currentIntent) {
        return [[]]
      }
      try {
        return vm.formatAnswer(vm.currentIntent.ms_team_val, 'json')
      } catch (error) {
        return [[]]
      }
    }
  },
  watch: {
    page(newVal, oldVal) {
      if (newVal != oldVal) {
        this.offset = (newVal - 1) * this.maxItems
        this.handleFetchAutoClassify()
      }
    },
    search(newVal, oldVal) {
      if (newVal != oldVal) {
        this.handleSearch()
      }
    }
  },
  async mounted() {
    this.handleLoadAll()
  },
  methods: {
    async handleLoadAll() {
      this.$store.state.selectConversationAutoTrainingID = ''
      this.$store.commit('SET_SELECTED_AUTO_TRAINING', [])
      this.handleFetchAutoClassify()
      this.handleGetSpamAndIgnoreConversation()
      this.handleFetchIntent()
    },
    async handleFetchIntent() {
      this.loadingIntent = true
      try {
        this.intents = []
        const intents = await this.getIntent()
        this.intents = intents
      } catch (error) {
        console.error(error)
      }
      this.loadingIntent = false
    },
    async onAddToConversation(payload) {
      this.$store.dispatch('loading')
      try {
        await this.handleAddAnswers(
          {
            id: payload.id,
            intentname: payload.intentname
          },
          payload.words
        )
        this.$store.dispatch('clear_loading')
        this.$store.state.selectConversationAutoTrainingID = ''
        this.$store.commit('SET_SELECTED_AUTO_TRAINING', [])
        if (payload.onSuccess) {
          payload.onSuccess()
        }
        this.handleLoadAll()
      } catch (error) {
        this.$store.dispatch('clear_loading')
        console.error(error)
        if (payload.onError) {
          payload.onError(error)
        }
      }
    },
    handleGoToConversation() {
      this.showDialogSuccessToAdd = false
      this.$router.push({
        name: 'conversation',
        query: {
          show_intent: this.addType
        }
      })
    },
    handleCloseSuccess() {
      this.showDialogSuccessToAdd = false
      this.addType = ''
    },
    handleCancelReview() {
      this.showDialogReviewToAdd = false
      this.addType = ''
    },
    async handleSubmitReview() {
      this.showDialogReviewToAdd = false
      this.showDialogConfirmToAdd = true
    },
    handleCancelConfirmReview() {
      this.showDialogConfirmToAdd = false
      this.addType = ''
    },
    async handleSubmitConfirmReview() {
      this.showDialogConfirmToAdd = false
      try {
        this.$store.dispatch('loading')
        // save to spam or ignore
        let responseTrainDefault = null
        if (this.addType == 'spam') {
          if (!this.spamConversation || !this.spamConversation.id) {
            // create new spam conversation
            const spamConversation = await this.handleCreateSpamOrIgnoreConversation(this.addType, {
              questiondata: this.selectedAutoTraining
            })
            this.spamConversation = spamConversation
          } else {
            await this.handleUpdateSpamOrIgnoreConversation(this.spamConversation, {
              questiondata: this.selectedAutoTraining
            })
          }

          const datapayload = {
            questiondata: this.selectedAutoTraining,
            intentname: this.spamConversation.intentname
          }
          responseTrainDefault = await this.updateTrainedToDefaultChatlog(datapayload)
        } else if (this.addType == 'ignored') {
          if (!this.ignoreConversation || !this.ignoreConversation.id) {
            // create new ignore conversation
            const ignoreConversation = await this.handleCreateSpamOrIgnoreConversation(
              this.addType,
              {
                questiondata: this.selectedAutoTraining
              }
            )
            this.ignoreConversation = ignoreConversation
          } else {
            await this.handleUpdateSpamOrIgnoreConversation(this.ignoreConversation, {
              questiondata: this.selectedAutoTraining
            })
          }
          const datapayload = {
            questiondata: this.selectedAutoTraining,
            intentname: this.ignoreConversation.intentname
          }
          responseTrainDefault = await this.updateTrainedToDefaultChatlog(datapayload)
        }
        this.$store.dispatch('clear_loading')
        if (responseTrainDefault == false) {
          await this.$swal({
            title: 'Error',
            text: 'เกิดข้อผิดพลาดในการบันทึกคำถาม',
            type: 'error'
          })
          return false
        } else {
          this.handleLoadAll()
          this.showDialogSuccessToAdd = true
        }
      } catch (error) {
        handleApiError(error)
        this.$store.dispatch('clear_loading')
      }
    },
    async handleCreateSpamOrIgnoreConversation(type, data) {
      const intent = {
        ...this.intentTemplate(),
        intentname: type,
        q_type: 'text',
        a_type: 'json',
        q_val:
          `{${type}}` +
          (data.questiondata && data.questiondata.length > 0
            ? `,${data.questiondata.join(',')}`
            : ''),
        a_val: '[[]]',
        pageid: this.selectedBot.pageid
      }
      const response = await api.addIntent(intent, null, true)
      if (response && response.data && response.data.responsecode == 200) {
        return {
          ...intent,
          id: response.data.id
        }
      } else {
        return false
      }
    },
    async handleUpdateSpamOrIgnoreConversation(conversation, data) {
      const intent = {
        ...conversation,
        q_val:
          conversation.q_val +
          (data.questiondata && data.questiondata.length > 0
            ? `,${data.questiondata.join(',')}`
            : '')
      }
      const response = await api.editIntent(intent, null, true)
      if (response && response.data && response.data.responsecode == 200) {
        return {
          ...intent,
          id: response.data.id
        }
      } else {
        return false
      }
    },
    async handleGetSpamAndIgnoreConversation() {
      let params = {
        pageid: this.selectedBot.pageid,
        limit: 100,
        offset: 0,
        page_intent: 'conversation',
        intent_name: '["spam","ignored"]',
        sort_by: 'intentname',
        sort_type_available: 'asc'
      }
      const response = await intentApi.getIntent({ params })
      if (response && response.data.data) {
        const conversations = response.data.data
        const spamConversation = conversations.find(
          (conversation) => conversation.intentname == 'spam'
        )

        const ignoreConversation = conversations.find(
          (conversation) => conversation.intentname == 'ignored'
        )
        this.spamConversation = spamConversation
        this.ignoreConversation = ignoreConversation
      }
    },
    async handleExportAnwsers() {
      const vm = this
      if (vm.loadingGetAutoTraining) {
        return false
      }
      vm.loadingGetAutoTraining = true
      const json = this.selectedAutoTraining.map((val) => ({
        message: (val ? val : '').replace(/\r?\n|\r/g, ' / ')
      }))

      const dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, 'auto-training.xlsx')
      vm.loadingGetAutoTraining = false
    },
    handleSelectPreviewIntent(intent) {
      if (!this.currentIntent || this.currentIntent.id != intent.id) {
        this.currentIntent = intent
      } else {
        this.currentIntent = null
      }
    },
    onCloseIntent() {
      this.currentView = 'list'
    },
    async onSaveIntent(payload) {
      this.loadingGetAutoTraining = true
      this.currentView = 'list'
      if (this.selectedAutoTraining) {
        this.loadingGetAutoTraining = true
        const datapayload = {
          questiondata: this.selectedAutoTraining,
          intentname: payload.intentname
        }
        const response = await this.updateTrainedToDefaultChatlog(datapayload)

        if (response) {
          this.handleLoadAll()
        }

        this.loadingGetAutoTraining = false
      }
      this.currentView = 'list'
    },
    async updateTrainedToDefaultChatlog(payload) {
      try {
        const response = await autoTrainingApi.putUpdateDefaultChatlog({
          data: {
            page_id: this.selectedBot.pageid,
            questiondata: payload.questiondata,
            newintent: payload.intentname
          }
        })
        if (response && response.status == 200) {
          return response
        }
      } catch (error) {
        console.error(error)
        handleApiError(error)
        return false
      }
    },
    async getIntent() {
      let vm = this
      const params = {
        pageid: vm.selectedBot.pageid,
        sort_by: 'intentname',
        sort_type_available: 'asc'
      }
      try {
        const response = await intentApi.getIntent({ params })
        await handleResponse(response)
        const data = response.data.data
        if (data) {
          const intents = data.map((val) => {
            let intent = val
            intent.isShow = false
            intent.ableToDelete = true
            if (intent.intentname == '{default}') {
              intent.ableToDelete = false
              vm.default_intent = intent
            } else {
              return intent
            }
          })
          return intents
        }
      } catch (error) {
        handleApiError(error)
      }
    },
    async handleAddToSpam() {
      if (this.selectedAutoTraining.length == 0) {
        await this.$swal({
          title: 'กรุณาเลือกคำตอบ',
          type: 'warning'
        })
        return false
      }
      this.addType = 'spam'
      this.showDialogReviewToAdd = true
    },
    async handleAddToIgnore() {
      if (this.selectedAutoTraining.length == 0) {
        await this.$swal({
          title: 'กรุณาเลือกคำตอบ',
          type: 'warning'
        })
        return false
      }
      this.addType = 'ignored'
      this.showDialogReviewToAdd = true
    },
    async handleAddToNewConversation() {
      if (this.selectedAutoTraining.length == 0) {
        await this.$swal({
          title: 'กรุณาเลือกคำตอบ',
          type: 'warning'
        })
        return false
      }
      this.newIntent = {
        intentname: '',
        q_type: 'text',
        a_type: 'json',
        q_val: this.selectedAutoTraining.join(','),
        a_val: '[[]]',
        context_in: '',
        context_out: '',
        postidlist: '',
        userstatus: '',
        usertags: '',
        isShow: false,
        linenoti_status: false,
        linenoti_text: null,
        starttime: null,
        endtime: null,
        intentstatus: true
      }
      this.currentView = 'create_new'
    },
    async saveToExistingConversation(intent) {
      let vm = this
      if (
        !vm.selectedAutoTraining ||
        (vm.selectedAutoTraining && vm.selectedAutoTraining.length == 0)
      ) {
        return false
      }

      const result = await vm.$swal.fire({
        title: vm.$t('Do you want to add {question} to {intent}?', {
          question: (vm.selectedAutoTraining[0] + (vm.selectedAutoTraining.length > 1 ? '...' : ''))
            // eslint-disable-next-line no-useless-escape
            .replace(/\<|\>/g, ''),
          // eslint-disable-next-line no-useless-escape
          intent: intent.intentname.replace(/\<|\>/g, '')
        }),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        vm.loadingGetAutoTraining = true
        vm.showDialogAddExisting = false
        try {
          await vm.handleAddAnswers(
            { intentname: intent.intentname, id: intent.id },
            this.selectedAutoTraining
          )
          vm.handleLoadAll()
          vm.loadingGetAutoTraining = false
        } catch (error) {
          console.error(error)
          vm.loadingGetAutoTraining = false
        }
      }
    },
    async handleAddAnswers(intent, words = []) {
      const data = {
        q_val: words.join(','),
        pageid: this.selectedBot.pageid,
        id: intent.id
      }
      const request = {
        data: data,
        params: {
          id: data['id']
        }
      }
      try {
        await this.putQvalIntents(request)
        if (words) {
          const datapayload = {
            intentname: intent.intentname,
            questiondata: words
          }

          const response = await this.updateTrainedToDefaultChatlog(datapayload)
          if (response) {
            this.handleLoadAll()
          }
        }
      } catch (error) {
        console.error(error)
        throw error
      }
    },
    putQvalIntents(request) {
      return new Promise((resolve, reject) => {
        api.putQvalIntents(request, function (error) {
          if (error) {
            reject(error)
          }

          resolve()
        })
      })
    },
    async handleAddToExistingConversation() {
      if (this.selectedAutoTraining.length == 0) {
        await this.$swal({
          title: 'กรุณาเลือกคำตอบ',
          type: 'warning'
        })
        return false
      }
      this.showDialogAddExisting = true
    },
    async handleFetchAutoClassify() {
      this.loadingGetAutoTraining = true
      const { data, total } = await this.handleGetAutoTraining()

      this.total = total
      this.conversations = data
      this.loadingGetAutoTraining = false
    },
    async handleSearch() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout)
      }
      this.searchTimeout = setTimeout(() => {
        this.offset = 0
        this.page = 1
        this.handleFetchAutoClassify()
      }, 2000)
    },
    async handleGetAutoTraining() {
      if (!this.$store.state.selectedBot) return
      try {
        const response = await autoTrainingApi.getAutoTraining({
          config: {
            params: {
              limit: this.maxItems,
              page_id: this.$store.state.selectedBot.pageid,
              offset: this.offset,
              search: this.search || undefined
            }
          }
        })
        if (response && response.status == 200) {
          return {
            data: response.data.data
              ? response.data.data.map((item) => {
                  let answers = []
                  let questiondata_array = []
                  try {
                    answers = item.answers ? JSON.parse(item.answers) : []
                    questiondata_array = item.questiondata_array.sort((a, b) => b.score - a.score)
                  } catch (error) {
                    console.error(error)
                  }
                  return { ...item, selected: false, answers, questiondata_array }
                }, [])
              : [],
            total: response.data.total
          }
        } else {
          return {
            data: [],
            total: 0
          }
        }
      } catch (error) {
        handleApiError(error)
        return {
          data: [],
          total: 0
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/Training/AutoClassify.vue